import EnrollmentForm from './form';

export default function enrollments () {
  document.addEventListener('DOMContentLoaded', () => {
    EnrollmentForm();
  });
}
